import { combineReducers } from "redux";

import product from "./product";

export default combineReducers({
  product,
});
